export default {
  login: {
    title: "SYSTEM LOGIN",
    logIn: "Login",
    username: "Account",
    password: "Password",
  },
  wrongpwd:
    "アルファベット大文字小文字+数字は8桁以下ではいけない,特殊記号の使用は当面対応しない",
  首页: "ウォレット",
  行情: "取引",
  财富: "資産",
  我的: "アカウント",
  忘记密码: "パスワードを探す",
  确定: "確認",
  "忘记密码？": "パスワードを忘れた場合",
  登录: "ログイン",
  注册: "会員登録",
  云端钱包: "ウォレット",
  世界顶尖安全保护: "世界一のセキュリティ",
  "独有资产增益，注册存币坐享收益": "限定資産を獲得。登録してコインを入金すると収益を得られます。",
  "支持超过30+主流币和500+代币":
    "30種類以上の主要コインおよび500種類以上のトークンに対応しています。",
  HD钱包: "HD wallet",
  "100%掌管私钥，资产更放心": "プライベートキーを100％管理、より安心できる資産",
  "一键导入助记词，方便好用":
    "ワンクリックでニーモニックフレーズをインポート、便利で使いやすい",
  设置登录密码: "パスワード設定",
  确认: "確認",
  手机注册: "携帯番号で登録",
  已有账号: "すでにアカウントがあります。",
  去登录: "ログイン",
  最近流行: "最新の人気",
  全部: "全部",
  拖动排序: "ドラッグして並べ替え",
  立即创建: "今作る",
  您支付: "お支払い額",
  可换余额: "両替可能額",
  请在以下时间内完成支付以锁定此汇率: "以下の時間内にお支払いを完了してください。この為替レートを確定できます。",
  您获得: "受け取った金額",
  "您获得的币种为空时,说明没有币种可以闪兑。":
    "コインが正しく選択されているか確認してください",
  立即兑换: "両替",
  备份钱包助记词: "ニーモニックに注意して保管してください",
  "1.由12个字符组成，请抄写并保管在安全的地方。":
    "1. 12個の単語を書いて保管してください。",
  "2.100%由您保管，一经丢失，无法找回。":
    "2. 100％ご自身で管理してください。一度失われた場合、取り戻すことはできません。",
  "3.请在收币或卸载之前，务必完成助记词备份。":
    "3. アプリ削除や入金前に必ずニーモニックを保管してください。",
  立即备份: "書いて保管してください。",
  "我先看看，稍后再说": "確認しています。",
  请环顾四周: "周辺に露出しないようにご注意ください。",
  "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。":
    "ニーモニックフレーズを入手した人は、あなたの資産を取得したことになります。必ず周囲に誰もいないこと、またカメラなどで撮影されていないことを確認してください。",
  知道了: "確認",
  请输入验证码: "認証コードを入力",
  "没有收到验证码？": "認証コードが届いていないですか？",
  交易时间: "取引時間",
  交易ID: "取引ID",
  来自: "差出人",
  发送到: "宛先",
  备注: "備考",
  发送: "出金",
  闪兑: "両替",
  接收: "入金",
  交易记录: "取引履歴",
  "正在刷新...": "リフレッシュ中",
  "正在加载...": "ローディング中",
  暂无相关记录: "履歴がありません",
  重新设置支付密码: "お支払いパスワードの再設定",
  "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证":
    "上記の16桁のリカバリーキーを安全な場所に必ずバックアップしてください。キーを紛失した場合、二段階認証を復元することはできません。",
  我已设置并备份秘钥: "ニーモニックバックアップおよび設定を完了しました。",
  "谷歌两步验证可以为您的账户增加一层保护，当您登陆或者进行交易时，在输入密码的同时，还需要来自两步验证的验证码":
    "Googleの二段階認証を設定すると、アカウントに追加の保護層を設けることができます。ログインや取引を行う際には、パスワードを入力するだけでなく、二段階認証で生成された確認コードの入力も必要になります。",
  "如何使用谷歌两步验证?": "Googleの二段階認証はどのように使用しますか？",
  筛选: "フィルター",
  移除: "削除",
  添加: "追加",
  总资产: "総資産",
  创建钱包: "ウォレット生成",
  导入钱包: "ウォレットインポート",
  邀请好友: "フレンドを招待",
  发红包: "プレゼント",
  扫一扫: "QRスキャン",
  地址簿: "アドレス帳",
  历史公告: "お知らせ",
  设置: "設定",
  请选择您的证件的颁发国家: "国を設定してください。",
  查看助记词: "ニーモニックを見る",
  "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。":
    "他のデバイスでペアリングするには、ニーモニックフレーズをインポートするか、別のデバイスの「HMC Wallet Pro」でQRコードをスキャンしてください。",
  "请勿截图！如果有人获取你的助记词将直接获取你的资产！":
    "スクリーンショットは絶対に撮らないでください！ニーモニックフレーズが他人に知られると、資産を直接盗まれる危険があります。",
  查看加密二维码: "暗号化QRコードを表示",
  "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。":
    "このQRコードは、新しいデバイスとウォレットをペアリングするために暗号化されています。スクリーンショットは保存しないでください。また、周囲に他人や隠しカメラがないことを必ず確認してください。",
  "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。":
    "このQRコードは、HMC Wallet Pro専用です。スキャンする際は、インポート先のアプリで現在のアプリのPINコードを入力すると、対応するニーモニックフレーズを正常にインポートできます。 ",
  "请抄写 HMC Wallet Pro 助记词": "HMC Wallet Pro のニーモニックフレーズをコピーしてください。",
  "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。":
    "HMC Wallet Pro のニーモニックフレーズは、ウォレットを復元するために使用されます。以下の12単語を順番どおりに紙に書き写し、安全な場所に保管してください。",
  我已安全保存: "安全に保管しました。",
  "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证":
    "HMC Wallet Pro では、セキュリティ認証を完了するために、政府発行の写真付き身分証明書の提出が必要です。",
  提交: "提出する",
  设置收款金额: "入金金額設定",
  收款金额: "入金金額 ",
  复制收款码: "決済額設定",
  取消: "取消し ",
  数量: "数量 ",
  "为了您的账户安全,请输入原支付密码确认身份。":
    "現在のパスワードを入力してください。",
  "忘记支付密码?": "パスワードを忘れましたか？",
  将配好的红包分享给好友: "友だちにプレゼントを共有しましょう。",
  个: "個",
  "请确认 HMC Wallet Pro 助记词": "HMC Wallet Pro のニーモニックフレーズを確認してください。",
  "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。":
    "正しく控えているか確認するため、指定された番号の単語を選択してください。",
  "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。":
    "セキュリティ強化のため、セキュリティ設定と本人確認が必要です。セキュリティレベルに応じた出金限度が設定されます。",
  恢复助记词钱包: "ニーモニックでウォレットを呼び込む。",
  "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词":
    "ウォレットを復元するため、以下のフォームにニーモニックフレーズを入力してください。各単語を入力後、「スペース」キーを押すと次の単語へ進みます。",
  开始恢复: "復元する",
  "覆盖当前钱包？": "呼び込んだウォレットを適用しますか？",
  "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。":
    "ウォレットをインポートすると、現在のウォレットは上書きされます。バックアップを取っていない場合、現在のウォレットは永久に失われます。",
  继续导入: "続く",
  全部发送: "すべて送金",
  交易费: "手数料",
  慢: "低速",
  快: "高速",
  已有红包: "すでにプレゼントをもらいました",
  生成红包: "プレゼント生成",
  确认支付: "確認",
  可在已有红包页面查看领取详情: "プレゼントページで内訳を確認してください。",
  级: "級",
  退出登录: "ログアウト",
  全部划转: "全部送る",
  查看规则: "規定表示",
  请输入支付密码: "お支払いパスワード入力",
  币计划活期: "預金",
  币计划定期: "ステーキング",
  预期年化收益: "年間予想収益率",
  我的财富: "総資産",
  币计划: "CoinPlan",
  热门推荐: "おすすめ商品",
  交易查询: "取引履歴",
  财富资产: "総資産",
  累计收益: "累積収益",
  预期年化收益率: "予想年収益率",
  交易规则: "取引規定",
  买入: "購入 ",
  起息日: "開始日",
  到期日: "満了日",
  产品亮点: "商品ハイライト",
  剩余额度: "残りの残額 ",
  立即购买: "すぐ購入 ",
  昨日收益: "昨日の収益",
  划入: "入金",
  划出: "送金",
  全部划出: "全部振替",
  请输入谷歌二次验证码: "Googleの二段階認証コードを入力してください。",
  点击登录: "ログイン ",
  "欢迎来到HMC Wallet Pro": "HMC Wallet Proへようこそ！",
  邀请奖励: "招待",
  每日快讯: "ニュース",
  联系客服: "お問い合わせ",
  邀请累计: "累積額",
  积分: "/ポイント",
  好友注册人数: "フレンド追加人数",
  好友注册: "フレンド登録",
  人数: "/人",
  一级好友数: "1レベルのフレンド",
  "积分 每人奖励": "1人あたり{msg}ポイント",
  二级好友数: "2レベルのフレンド",
  三级好友数: "3レベルのフレンド",
  一级好友数2: "1レベルのフレンド",
  二级好友数2: "2レベルのフレンド",
  三级好友数2: "3レベルのフレンド",
  "积分 每人奖励2": "1人あたり{msg}ポイント",
  好友存币数: "入金したフレンド",
  邀请列表: "招待リスト",
  邀请注册: "招待登録",
  邀请存币: "招待入金",
  暂时没有邀请哦: "招待がありません",
  当前总额: "現有総資産",
  积分账单: "ポイントの内訳",
  任务: "ミッション",
  商城: "ショッピングモール",
  "忘记PIN码？备份钱包后重新安装App并导入助记词后重置":
    "PINコードをお忘れですか？ウォレットをバックアップした後、アプリを再インストールし、ニーモニックフレーズをインポートしてからリセットしてください。",
  "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。":
    "資産のセキュリティのために、PINコードを設定してください。PINコードはウォレットをロックから解除する、送金する際に使用されます。",
  "PIN码为本地密码，请妥善保存，如果丢失，无法恢复":
    "PINコードは端末内で使用されるローカルパスワードです。厳重に管理してください。紛失すると、復元はできません。",
  关闭PIN码: "PINコードを閉じる",
  "扫码下载HMC Wallet Pro": "QRコードをスキャンして、HMC Wallet Proをダウンロードします",
  "邀请码(点击复制)": "招待コード(コピー)",
  查看邀请详情: "招待の詳細を見る",
  我的订单: "私の購入",
  正在进行中: "進行中",
  已经结束: "満期",
  人参与: "名参加中",
  兑换金额: "交換金額",
  商品详情: "商品説明",
  兑换时间: "交換時間",
  开始时间: "開始時間",
  结束时间: "満期時間",
  我的积分: "私のスコア",
  我的剩余兑换额度: "残りの交換残高",
  库存总量: "総残高 ",
  剩余库存: "残余残高 ",
  兑换比例: "交換比率",
  确认兑换: "交換確認",
  任务记录: "ミッションの記録",
  分享: "シェア",
  请填写手机号: "携帯番号を入力",
  验证码: "認証コードを入力",
  设置密码: "パスワードを入力",
  再次输入: "パスワードを再入力",
  请填写密码: "パスワードを入力",
  邀请码: "招待コード(選択)",
  我的Dapp钱包: "My Dapp Wallet",
  发现: "探す",
  搜索: "検索",
  自定义排序: "整列設定",
  货币: "貨幣",
  创建新地址: "新しいアドレスを生成",
  名称: "コイン名",
  地址: "アドレス",
  请输入金额: "金額を入力",
  验证您的身份: "身分認証",
  选择币种: "貨幣選択",
  设置支付密码: "お支払いパスワード設定",
  谷歌两步验证码: "Google二段階認証コード",
  谷歌两步验证: "Google二段階認証",
  请输入搜索内容: "検索内容を入力してください。",
  选择证件类型: "身分証明書の種類選択",
  支付密码: "お支払いパスワード",
  修改支付密码: "パスワードの変更",
  认证资料: "認証情報",
  国家: "国家",
  您的居住国家: "現在の居住国家",
  姓名: "氏名",
  您的姓名全称: "氏名を入力してください。",
  生日: "誕生日",
  居住地: "居住地",
  您现在的居住地: "現住地",
  证件ID: "身分証",
  您的证件ID号码: "身分証の番号",
  ID正面照片: "身分証の正面写真",
  ID反面照片: "身分証の裏面写真",
  请输入数值: "数量を入力してください。",
  已配置红包: "プレゼント設定完了",
  重置支付密码: "パスワード変更",
  红包详情: "プレゼント詳細",
  安全等级: "セキュリティレベル",
  请输入收款地址: "入金アドレスを入力",
  "备注(选填)": "備考",
  配置红包: "プレゼント設定",
  金额: "金額",
  红包数: "プレゼント数量",
  请填写个数: "数量を入力してください。",
  红包总额度: "プレゼント総数量",
  红包数量: "プレゼント数量",
  祝福语: "メッセージ",
  选择发送途径: "送信方法を選択",
  云端钱包设置: "設定",
  账户名称: "アカウント名",
  注册时间: "登録日時",
  请输入划入金额: "入金金額を入力してください。",
  请输入转出金额: "送金金額を入力してください。",
  谷歌二次验证: "Google二段階認証",
  默认货币: "表示通貨",
  PIN码: "PINコード",
  行情选项: "相場選択",
  服务协议: "利用規約",
  隐私政策: "プライバシーポリシー",
  帮助中心: "カスタマーセンター",
  加入社群: "Telegram",
  我的邀请: "招待状況を表示 ＞",
  验证PIN码: "PINコードを認証",
  设置PIN码: "PINコードを設定",
  行情显示色选项: "相場表示色を選択",
  请输入兑换金额: "交換金額を入力してください ",
  任务中心: "ミッションセンター",
  快讯: "新報",
  "已开启(重置)": "オープン（リセット）",
  已开启: "オープン",
  未开启: "未オープン",
  绿涨红跌: "Up:緑/Down:赤",
  红涨绿跌: "Up:赤/Down:緑",
  "我已备份好当前钱包，同意覆盖": "変更を適用しますか？",
  "助记词即为私钥，它是掌管您财产的钥匙":
    "ニーモニックは資産を管理できるプライベートキーです。",
  "没有HMC Wallet Pro账号？": "アカウントを持っていませんか？",
  请填写完整: "空欄を全て埋めてください。",
  复制成功: "コピー成功 ",
  复制出现异常: "コピー失敗",
  获取验证码: "認証コード送信",
  验证错误: "検証エラー",
  验证成功: "正常に検証されました",
  验证失败: "検証に失敗しました",
  设置成功: "正常に設定",
  请选择同意: "同意してください",
  云端钱包公告: "クラウドウォレットのお知らせ",
  HD钱包公告: "HDウォレットのお知らせ",
  云端钱包地址簿: "クラウドウォレットアドレス帳",
  HD钱包地址簿: "HDウォレットアドレス帳",
  收款地址: "入金アドレス",
  资产名: "アセット名",
  交易量: "出来高",
  价格: "価格",
  "涨跌幅(24H)": "変更(24H)",
  全部交易: "全取引 ",
  增益收入: "収益",
  全部产品: "全商品 ",
  全部币种: "全コイン",
  当前余额: "残高",
  钱包: "ウォレット",
  今日获得: "今日入手",
  备份助记词: "バックアップニーモニック",
  完成: "終了",
  下一步: "次のステップ",
  默认语言: "言語設定",
  内部转账: "内部送金",
  外部转账: "外部送金",
  请输入收款用户ID: "宛先IDを入力してください",
  公链: " チェーン",
  游戏: "ゲーム",
  手机登录: "携帯番号で登録",
  我的游戏: "私のゲーム",
  社区: "コミュニティ",
  链游: "関連商品 ",
  全部动态: "全ての投稿",
  热门游戏: "トップゲーム",
  我的关注: "お気に入り",
  发布: "投稿",
  分享新鲜事: "あなたの最近をシェアしましょう",
  发布动态: "投稿する",
  个人主页: "プロフィール編集",
  全文: "全文",
  评论: "コメント",
  赞: "いいね",
  没有更多了: "最後です",
  暂无数据: "データがありません",
  提示: "ヒント",
  "提币前必须绑定google验证码": "出金する前にGoogle認証を連動する必要があります",
  请选择文件: "ファイルを選択してください",
  请输入动态内容: "投稿内容を入力してください",
  确定删除该图片吗: "この画像を削除してもよろしいですか",
  上传文件类型错误: "アップロードファイルの種類が正しくありません",
  请选择要上传的图片: "アップロードする画像を選択してください",
  匿名用户: "匿名ユーザー",
  收起: "片付け",
  查看所有评论: "全てのコメントを見る",
  确定删除该动态吗: "このアクティビティを削除してもいい",
  动态详情: "投稿詳細",
  删除: "削除",
  有趣的评论万里挑一: "面白いコメントは100万分の1",
  请输入内容: "内容を入力してください",
  回复: "返信する",
  暂无签名: "署名がまだありません",
  已关注: "フォローしました",
  关注: "フォロー",
  删除成功: "正常に削除されました",
  打开: "開ける",
  写下你的评论: "レビューを書く",
  个人资料: "ユーザー情報",
  点击修改: "クリックして変更",
  昵称: "ニックネーム",
  ID: "ID",
  手机号: "携帯番号",
  个性签名: "ステータスメッセージ",
  添加图片或视频: "画像/動画の追加",
  可用资产: "使用可能アセット",
  锁定资产: "凍結されたアセット",
  转账: "送金",
  收款: "入金",
  钱包管理: "招待",
  锁仓截止日期: "ロックアップ期限",
  锁定: "ロック",
  交易所: "取引所 ",
  量化交易: "定量的取引",
  角色信息: "役割情報",
  绑定角色: "バインド役割",
  服务区: "サービスエリア",
  请选择服务区: "サービスエリアを選択してください",
  角色: "役割",
  请选择角色: "役割を選択してください",
  绑定: "バインド",
  绑定成功: "バインドに成功しました",
  立即绑定: "今すぐバインド",
  未绑定: "バインドできませんでした",
  MetaEx交易所: "MetaEarth取引所",
  AI机器人: "Alボット",
  邮箱注册: "メールで登録 ",
  请填写邮箱号: "メールアドレスを入力 ",
  返回首页: "ウォレット",
  BTC公链: "BTCチェーン",
  ETH公链: "ETHチェーン",
  HMC公链: "HMCチェーン",
  HMC20: "HMC-20",
  实名认证: "本人確認",
  请先设置支付密码: "最初に支払いパスワードを設定してください",
  立即认证: "今すぐ認証する",
  已认证: "認証済み",
  谷歌验证器: "Google認証",
  两步验证: "二段階認証",
  "如何使用谷歌验证器?": "Goolge認証の設定方法",
  所有币种: "すべての通貨",
  已添加币种: "通貨が追加されました",
  未添加币种: "通貨は追加されません",
  邮箱: "メールアドレス",
  手机: "携帯番号",
  获取: "入手",
  推荐: "お勧め",
  利空: "弱気",
  利好: "強気",
  请填写完整的助记词: "完全なニーモニックフレーズを入力してください",
  "不是正确的助记词,请重新输入":
    "正しいニーモニックではありません。再入力してください",
  empty: "完全に記入されているか確認してください",
  noequal: "2つの入力欄が等しくありません",
  invite: "6桁の招待コードを入力してください",
  邮箱登录: "メールでログイン",
  待审核: "審査待ち",
  修改密码: "パスワードの変更",
  认证失败: "認証失敗",
  旧密码: "旧パスワード",
  新密码: "新パスワード",
  请确认新密码: "新パスワードを再入力",
  立即修改: "確認",
  请填写完整表单: "完全なフォームに記入してください",
  两次密码不一致: "パスワードが一致しません",
  认证状态: "本人確認",
  身份认证失败: "認証失敗",
  失败原因: "失敗の原因",
  重新认证: "再認証",
  审核中: "審査中",
  已完成身份认证: "本人確認完了",
  国籍: "国籍",
  类型: "身分証明書の種類 ",
  身份证: "身分証明証",
  护照: "パスポート",
  驾照: "免許",
  证件号码: "パスポート番号",
  已完成实名认证: "本人認証完了",
  身份验证: "認証",
  请输入手机验证码: "モバイル認証番号を入力してください",
  发送验证码: "認証コード送信",
  请输入邮箱验证码: "認証コードを入力 ",
  请输入谷歌验证码: "Google認証番号を入力してください",
  输入邮箱验证码: "メールに届いた認証コードの入力 ",
  输入手机验证码: "モバイル認証番号入力",
  输入谷歌验证码: "Google認証番号入力",
  谷歌验证: "Google認証",
  立即验证: "確認",
  发送验证码至手机: "携帯認証コードを送信する",
  发送验证码至邮箱: "メールに認証番号を送信する",
  忘记支付密码: "PINコードを忘れた場合",
  输入新密码: "新PINコードを入力してください",
  请再次输入: "新PINコードを再入力してください",
  请输入密码: "新PINコードを入力してください",
  请输入邮箱: "メールアドレスを入力してください",
  绑定邮箱: "バインドメール",
  请输入手机号: "電話番号を入力してください",
  区号: "エリアコード",
  请选择区号: "エリアコードを選択してください",
  绑定手机号: "モバイル連動",
  "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码":
    "Google認証を有効にすると、アカウントのセキュリティが強化されます。ログインや取引時には、パスワードとGoogle認証コードの両方を入力する必要があります。",
  // "如何使用谷歌验证器?": "google認証の使い方?",
  可用余额不足: "残高不足",
  地址格式不正确: "アドレスの形式が間違っています",
  金额不足10: "金額が10未満です",
  提币数量不能小于: "入力したコイン数が足りません",
  "您还未进行实名认证,请先进行实名认证":
    "まだ本人認証が完了していません。先に本人認証を行ってください。",
  至少为10: "少なくとも10以上",
  全选: "すべて選択",
  删除: "キャンセル",
  请先勾选地址: "住所にチェックを入れてください",
  新建地址: "新しいアドレス",
  提币网络: "ネットワーク",
  收款网络: "ネットワーク",
  "操作成功!": "処理成功",
  韩国: "韓国",
  日本: "日本",
  其他: "その他",
  请上传手持证件照片: "身分証明書の写真をアップロードしてください",
  请把信息填写完整: "情報をすべて記入してください",
  请上传所需图片: "必要な画像をアップロードしてください",
  两步验证登录: "ログイン認証",
  请选择验证方式: "認証方法を選んでください",
  验证方式: "認証方法を選択",
  验证登录: "検証する",
  短信验证: "SNS認証",
  邮箱验证: "メール認証",
  证件类型: "タイプ",
  暂无内容: "内容がありません",
  邮箱地址不符合格式: "メールアドレスの形式が合っていません",
  下拉刷新: "下に引いて更新する",
  释放更新: "更新を適用する",
  修改个性签名: "ステータスメッセージの編集",
  修改昵称: "ニックネームの編集",
  导入NFT: "NFTのインポート",
  请输入NFT合约地址: "NFTコントラクトアドレスを入力してください",
  请输入收藏品ID: "コレクション ID を入力してください",
  币种: "通貨",
  添加收藏品: "お気に入りを追加",
  暂无NFT收藏: "NFT コレクションはまだありません",
  确认删除此专辑吗: "このアルバムを削除してもよろしいですか",
  确认删除此收藏品吗: "このコレクションを削除してもよろしいですか",
  编号: "シリアルナンバー",
  删除收藏品: "コレクションを削除",
  保存收款码: "QRコード保存",
  PoS挖矿: "PoSマイニング",
  加入社群2: "Telegramに参加",
  "没有HMC Wallet Pro账号？ 注册": "会員登録",
  手机验证: "携帯番号認証",
  "已有账号，去登录": "登録済みの場合はここをタップ",
  导入NFT: "NFTのインポート",
  接收地址: "受信アドレス",
  添加收藏品: "お気に入りを追加",
  暂无NFT收藏: "NFT コレクションはまだありません",
  编号: "シリアルナンバー",
  删除: "削除",
  转出: "送金",
  确认删除此收藏品吗: "このコレクションを削除してもよろしいですか?",
  确认删除此专辑吗: "このアルバムを削除してもよろしいですか",
  地址: "住所",
  请输入NFT合约地址: "NFTコントラクトアドレスを入力してください",
  请输入收藏品ID: "コレクションIDを入力してください",
  添加: "追加",
  NFT接收地址: "NFT受信アドレス",
  复制: "コピー",
  此地址仅用于NFT钱包地址接收使用:
    "このアドレスは、NFTウォレットアドレスの受信にのみ使用されます",
  转出NFT: "NFTを送信する",
  合约地址: "コントラクトアドレス",
  转出网络: "ネットワークから送信",
  藏品编号: "コレクション番号",
  转出地址: "宛先住所",
  "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。":
    "この取引は元に戻すことができません。資産の損失を避けるため、転送アドレスとネットワークが正確かどうかを慎重に確認してください",
  请输入转出地址: "宛先を入力してください",
  NFT历史记录: "NFTヒストリー",
  时间: "時間",
  转入详情: "送金詳細",
  已转出: "送金完了",
  交易详情: "取引詳細",
  发送地址: "宛先",
  接收地址: "受信アドレス",
  网络: "ネットワーク",
  交易哈希: "取引ハッシュ",
  NFT合约地址: "NFTコントラクトアドレス",
  NFT编号: "NFT番号",
  交易时间: "取引時間",
  最小提币金额: "最小引き出し金額",
};
